// const Navbar = () => (
//     <div style={{padding:'15px 40px', background:'#151921', borderBottom:'1px solid #2d3748', textAlign:'right'}}>
//         <span>{localStorage.getItem('user_email')}</span>
//         {/* <button onClick={() => {localStorage.clear(); window.location.href='/login'}} style={{marginLeft:'20px', color:'red', background:'none', border:'none', cursor:'pointer'}}>Logout</button> */}
//     </div>
// );
// export default Navbar;

// // Styles
// const navStyle = {
//   padding: "12px 24px",
//   cursor: "pointer",
//   color: "var(--text-dim)",
// };




import React from "react";
import { useNavigate, Link } from "react-router-dom";
import logo from "../assets/salescott.png";

const Navbar = () => {
  const navigate = useNavigate();
  const userEmail = localStorage.getItem("user_email");

  return (
    <div
      style={{
        padding: "0 36px",
        height: "clamp(65px, 6vw, 85px)",
        background: "#ffffff",
        borderBottom: "1px solid #e9d5ff",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        fontFamily: "'Plus Jakarta Sans', sans-serif",
      }}
    >
      {/* Left Side: Brand/Home Link */}
      <Link 
        to="/tracker" 
        style={{ 
          display: "flex",
          alignItems: "center",
          gap: "10px",
          textDecoration: "none",
          margin: "0",
          padding: "0",
          lineHeight: "1",
        }}
      >
        <img 
          src={logo} 
          alt="SalesScott Logo" 
          style={{ 
            height: "clamp(48px, 5.2vw, 76px)", 
            maxHeight: "85px",
            width: "auto", 
            objectFit: "contain", 
            margin: "0", 
            padding: "0", 
            display: "block",
            transition: "height 0.2s ease"
          }} 
        />
      </Link>

      {/* Right Side: User Email */}
      <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
        <span
          onClick={() => navigate("/profile")}
          style={{
            cursor: "pointer",
            color: "#475569",
            fontSize: "14px",
            transition: "0.2s",
            fontWeight: "600",
          }}
          onMouseOver={(e) => (e.target.style.color = "#7c3aff")}
          onMouseOut={(e) => (e.target.style.color = "#475569")}
        >
          👤 {userEmail}
        </span>
      </div>
    </div>
  );
};

export default Navbar;